import React from "react";
function LTC(){
    return(
        <div>
        Indisponivel
        </div>
    )

}

export default LTC;